import { createRoot } from 'react-dom/client';
import { Admin, Resource, Loading, fetchUtils, DataProvider } from 'react-admin';
import postgrestRestProvider,
     { IDataProviderConfig,
       defaultPrimaryKeys,
       defaultSchema } from '@raphiniert/ra-data-postgrest';

import { searchProvider } from './utils/searchProvider';

import L from 'leaflet';
// import { isDeepStrictEqual } from 'util';
import 'leaflet/dist/leaflet.css';
import './utils/leaflet-setup';

import { config } from './config';
import { authProvider, httpClient } from './auth';

import { Dashboard } from './pages/dashboard';
import { AnswerList, AllAnswerIcon, PendingAnswerIcon } from './pages/answer';
import { CheckList } from './pages/check';
import { RedactList, RedactAnswerIcon } from './pages/redact';
import { ParticipantList, ParticipantIcon } from './pages/participant';
import { SettingsEdit, SettingsList, SettingsIcon } from './pages/settings';
import { SearchList } from './pages/search';
import { EventList, EventsIcon } from './pages/events';
import { SessionList, SessionShow, SessionsIcon } from './pages/sessions';

const root = createRoot(document.getElementById('root')!);
const dataProviderConfig: IDataProviderConfig = {
  apiUrl: config.apiUrl,
  httpClient: httpClient,
  defaultListOp: 'eq',
  // Note: If update operations fail, verify that 'id' is the primary key in the PostgREST schema
  primaryKeys: defaultPrimaryKeys,
  schema: defaultSchema
} 

// Create the postgrest provider
const postgrestProvider = postgrestRestProvider(dataProviderConfig);

// Create composite dataProvider that routes requests appropriately
const compositeDataProvider = {
  ...postgrestProvider,
  getList: (resource: string, params: any) => {
    if (resource === 'nlsearch') {
      return searchProvider('getList', resource, params);
    }
    return postgrestProvider.getList(resource, params);
  },
};

root.render(
  <Admin
    dashboard={Dashboard}
    authProvider={authProvider}
    dataProvider={compositeDataProvider}
    loading={Loading}
  >
    <Resource
      name="pending_answer"
      options={{ label: 'Pending Moderation' }}
      icon={PendingAnswerIcon}
      list={AnswerList}
    />

    <Resource
      name="check"
      options={{ label: 'Check Transcripts' }}
      icon={RedactAnswerIcon}
      list={CheckList}
    />

    <Resource
      name="redact"
      options={{ label: 'Redact' }}
      icon={RedactAnswerIcon}
      list={RedactList}
    />

    <Resource
      name="answer"
      options={{ label: 'Analyse Answers' }}
      icon={AllAnswerIcon}
      list={AnswerList}
    />

<Resource
      name="nlsearch"
      options={{ label: 'Semantic Search' }}
      icon={AllAnswerIcon}
      list={SearchList}
    />

    <Resource
      name="participant"
      icon={ParticipantIcon}
      list={ParticipantList}
    />

    <Resource
      name="event"
      options={{ label: 'Events' }}
      icon={EventsIcon}
      list={EventList}
    />

    <Resource
      name="session"
      options={{ label: 'Login Sessions' }}
      icon={SessionsIcon}
      list={SessionList}
      show={SessionShow}
    />

    <Resource
      name="config"
      options={{ label: 'System Settings' }}
      icon={SettingsIcon}
      edit={SettingsEdit}
      list={SettingsList}
    />

    {/* Note: This is not a listed-resource, but we use it in the dashboard so
        need to specify it as a resource to ensure the redux-selector stuff works
        and useGetList actually gives us our data back! */}
    <Resource name="accepted_answer" />
  </Admin>
);
